import React, { useState, useEffect } from 'react';
import { ClockIcon, MoonIcon, SunIcon, PlayIcon, StopIcon } from '@heroicons/react/20/solid';
import { useNavigate } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import LoadingComponent from '../manager/loading';
import { motion, AnimatePresence } from 'framer-motion';
import { useContext } from 'react';
import { AuthContext } from '../AuthContext';

export default function StaffActions() {
  const [staffList, setStaffList] = useState([]);
  const [clock, setClock] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [breakData, setBreakData] = useState([]);
  const [reload, setReload] = useState(false);
  const [error, setError] = useState(null);
  const [lateArrival, setLateArrival] = useState(false);
  const [reason, setReason] = useState('');
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);


  const navigate = useNavigate();

const user = useContext(AuthContext);

console.log(staffList);
console.log(breakData);

  const fetchStaff = async () => {
    try {
      // Fetch staff data
      const staffResponse = await fetch('https://api.insightos.co.uk/api/staff', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials : 'include',

      });

      const staffData = await staffResponse.json();

      if (!staffResponse.ok) {
        throw new Error(staffData.message || 'Failed to fetch staff data.');
      }



     // map through all the staff and only show where user.id is the same as the staff id
      const staff = staffData.data.filter((staff) => staff.id === user.id);

      // Fetch clock-in data
      const clockInResponse = await fetch('https://api.insightos.co.uk/api/myclockins', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials : 'include',

      });

      const clockInData = await clockInResponse.json();

      if (!clockInResponse.ok) {
        throw new Error(clockInData.message || 'Failed to fetch clock-in data.');
      }

      const clockInDataAll = clockInData.data;

      // Debug logging
      console.log('ClockIn Data:', clockInDataAll);

      const breakData = clockInData.breaks;

      setBreakData(breakData);

      // Process and merge data
      const staffWithClockInStatus = staff.map((staffMember) => {
        const id = staffMember.id;
        const today = format(new Date(), 'yyyy-MM-dd'); // Format the date to 'YYYY-MM-DD'

        const clockInDataForUser = clockInDataAll.find(
          (c) => {
            // Convert ISO date to comparable format
            const clockInDate = parseISO(c.Date);
            const clockInDateFormatted = format(clockInDate, 'yyyy-MM-dd');
            
            return c.StaffId === id && clockInDateFormatted === today;
          }
        );

        // Debug logging
        console.log(`Staff Member: ${staffMember.Name}`);
        console.log(`ClockInDataForUser:`, clockInDataForUser);

        return {
          ...staffMember,
          isClockedIn: clockInDataForUser ? clockInDataForUser.ClockedIn === 1 && clockInDataForUser.ClockedOut === 0 : false,
          isOnBreak: clockInDataForUser ? clockInDataForUser.Break === 1 : false,
          breakStartTime: clockInDataForUser ? clockInDataForUser.BreakStart : null,
          breakEndTime: clockInDataForUser ? clockInDataForUser.BreakEnd : null,
          clockInTime: clockInDataForUser ? clockInDataForUser.ClockIn : null, // Add ClockIn field here
          clockOutTime: clockInDataForUser ? clockInDataForUser.ClockOut : null, // Add ClockOut field here
          clockedOut : clockInDataForUser ? clockInDataForUser.ClockedOut === 1 : false, // Add ClockOut status here
          beforeClockin: !clockInDataForUser // if there is no data for clockin today, then beforeClockin is true
        };
      });

      // Debug logging
      console.log('Staff with Clock-In Status:', staffWithClockInStatus);

      setStaffList(staffWithClockInStatus);
    } catch (error) {
      console.error('Error fetching staff data:', error);
    }
  };

  useEffect(() => {
    fetchStaff();
  }, [reload]);


  

  console.log('Staff List:', staffList);


    const handleClockInOut = async (staff) => {
        setIsLoading(true); // Start loading

        const id = staff.id;
        const now = new Date();
        const timeOnly = format(now, 'HH:mm:ss');
        const dateOnly = format(now, 'yyyy-MM-dd');

        try {
            // Function to get GeoTag based on browser environment
            const getGeoTag = () =>
                new Promise((resolve, reject) => {
                    if (navigator.geolocation) {
                        // Browser environment: Use navigator.geolocation
                        navigator.geolocation.getCurrentPosition(
                            (position) => {
                                const { latitude, longitude } = position.coords;
                                resolve(`${latitude},${longitude}`); // Resolve with latitude and longitude
                            },
                            (error) => {
                                console.error('Geolocation error:', error);
                                resolve('Unknown'); // Default if geolocation fails
                            }
                        );
                    } else {
                        console.error('Geolocation is not supported in this environment.');
                        resolve('Unknown'); // Fallback if geolocation is not supported
                    }
                });

            const geoTag = await getGeoTag(); // Await geolocation

        const clockInResponse = await fetch('https://api.insightos.co.uk/api/myclockins', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials : 'include',

        });

        const clockInData = await clockInResponse.json();
        const clockInDataAll = clockInData.data;

        console.log('ClockIn Data:', clockInDataAll);

        const clockInDataFiltered = clockInDataAll.find((c) => {
            const clockInDate = parseISO(c.Date);
            const clockInDateFormatted = format(clockInDate, 'yyyy-MM-dd');
            return c.StaffId === id && clockInDateFormatted === dateOnly;
        });

        // Debug logging
        console.log(`ClockInDataForUser:`, clockInDataFiltered);

        if (clockInDataFiltered && clockInDataFiltered.ClockedIn === 1 && clockInDataFiltered.ClockedOut === 0) {
            // Staff member is already clocked in, update ClockOut time and GeoTag
            const clockInTime = new Date(`${dateOnly}T${clockInDataFiltered.ClockIn}`);
            const clockOutTime = now;

            // Calculate shift length in minutes
            const shiftLengthInMinutes = (clockOutTime - clockInTime) / 60000;
            const totalPay = shiftLengthInMinutes * (staff.HourlyRate / 60); // Convert hourly rate to per minute rate

            await fetch(`https://api.insightos.co.uk/api/clockin/addput/${clockInDataFiltered.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials : 'include',
                body: JSON.stringify({
                    ClockOut: timeOnly,
                    ClockedOut: 1,
                    ClockedIn: 0,
                    HoursWorked: parseFloat(shiftLengthInMinutes) / 60, // Convert minutes to hours
                    TotalPay: parseFloat(totalPay),
                    GeoTag: geoTag, // Save GeoTag for clock out
                }),
            });

            console.log(`${staff.Name} clocked out with GeoTag: ${geoTag}`);
            navigate('/logout');
            } else {
                // Fetch today's shifts
                const todaysshiftResponse = await fetch('https://api.insightos.co.uk/api/todaysshift', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                });

                if (!todaysshiftResponse.ok) {
                    throw new Error('Failed to fetch todaysshift data.');
                }

                const todaysshiftData = await todaysshiftResponse.json();
                const todaysshift = todaysshiftData.data;

                // Check the StaffId of the staff member and match it with the StaffId of the shift
                const shift = todaysshift.find((shift) => shift.StaffId === id);

                console.log('Matched Shift:', shift);

                if (!shift) {
                    throw new Error('No shift found for the staff member.');
                }

                // Find the shift start time
                const shiftStartTime = shift.StartTime;

                // Check if the staff member is late
                const late = shiftStartTime < timeOnly ? 1 : 0;

                console.log(`Staff member is late: ${late}`);

                console.log(`Shift Start Time: ${staff.Role}`);

                // Save a new ClockIn entry with GeoTag
                const response = await fetch('https://api.insightos.co.uk/api/clockin/add', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                    body: JSON.stringify({
                        ClockIn: timeOnly,
                        ClockedIn: 1,
                        ClockedOut: 0,
                        HourlyRate: staff.HourlyRate,
                        StaffId: staff.id,
                        Date: dateOnly,
                        Department: staff.Role,
                        StaffName: staff.Name,
                        Late: late,
                        GeoTag: geoTag, // Save GeoTag for clock in
                    }),
                });

                if (late === 1) {
                  setLateArrival(true);
                }

            

              const result = await response.json();

                 if (result?.Sick === 1) {
          setTimeout(() => navigate('/back-to-work'), 500);
        }


                console.log(`${staff.Name} clocked in with GeoTag: ${geoTag}`);
            }
        } catch (error) {
            console.error('Error handling clock in/out:', error);
            setError('No Shift Found For This Staff Member, Cannot Clock In');
        }

        setIsLoading(false);
        fetchStaff(); // Refresh staff data
    };

  const handleLateArrivalSubmit = async () => {

    console.log(user.manager)

    setIsLoading(true);
    try {
      await fetch('https://api.insightos.co.uk/api/clockin/addlatearrival', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          Date: format(new Date(), 'yyyy-MM-dd'),
          Reason: reason,
          Manager: user.manager
        }),
      });
      setLateArrival(false);
      setReason('');
      setTimeout(() => fetchData(), 500);
    } catch (err) {
      setError('Failed to submit late arrival reason');
    } finally {
      setIsLoading(false);
    }
  };



const handleBreakStartEnd = async (staff) => {
  setIsLoading(true); // Start loading
  const id = staff.id;
  const now = new Date();
  const timeOnly = format(now, 'HH:mm:ss');
  const dateOnly = format(now, 'yyyy-MM-dd');

  console.log('Break Data:', breakData);
  console.log('Starting break action for staff:', staff.Name);

  try {
      // Get GeoTag information
      const getGeoTag = () =>
          new Promise((resolve, reject) => {
              if (navigator.geolocation) {
                  navigator.geolocation.getCurrentPosition(
                      (position) => {
                          const { latitude, longitude } = position.coords;
                          resolve(`${latitude},${longitude}`);
                      },
                      (error) => {
                          console.error('Geolocation error:', error);
                          resolve('Unknown'); // Default if geolocation fails
                      }
                  );
              } else {
                  console.error('Geolocation is not supported by this browser.');
                  resolve('Unknown');
              }
          });

      const geoTag = await getGeoTag(); // Await geolocation

      const clockInResponse = await fetch('https://api.insightos.co.uk/api/clockin', {
          method: 'GET',
          headers: {
              'Content-Type': 'application/json',
          },
          credentials: 'include',
      });

      const clockInData = await clockInResponse.json();
      const clockInDataAll = clockInData.data;

      const clockInDataFiltered = clockInDataAll.filter((c) => {
          const clockInDate = parseISO(c.Date);
          const clockInDateFormatted = format(clockInDate, 'yyyy-MM-dd');
          return c.StaffId === id && clockInDateFormatted === dateOnly;
      });

      console.log('Clock-in data filtered:', clockInDataFiltered);

      if (clockInDataFiltered.length > 0 && clockInDataFiltered[0].Break === 1) {
          // If the staff member is on break, update the BreakEnd time, GeoTag, and Break status
          console.log('Ending break for:', staff.Name);
          const breakStart = new Date(`${dateOnly}T${clockInDataFiltered[0].BreakStart}`);
          const breakEnd = now;
          const breakLength = (breakEnd - breakStart) / 60000; // Calculate break length in minutes

          await fetch(`https://api.insightos.co.uk/api/clockin/breakend/${clockInDataFiltered[0].id}`, {
              method: 'PUT',
              headers: {
                  'Content-Type': 'application/json',
              },
              credentials: 'include',
              body: JSON.stringify({
                  BreakEnd: timeOnly,
                  Break: 0,
                  StaffBreak: parseFloat(breakLength),
                  GeoTag: geoTag, // Save GeoTag for BreakEnd
              }),
          });

          console.log(`${staff.Name} ended break with GeoTag: ${geoTag}`);
      } else if (clockInDataFiltered.length > 0) {
          // If the staff member is not on break, update the BreakStart time, GeoTag, and Break status
          console.log('Starting break for:', staff.Name);
          await fetch(`https://api.insightos.co.uk/api/clockin/breakstart/${clockInDataFiltered[0].id}`, {
              method: 'PUT',
              headers: {
                  'Content-Type': 'application/json',
              },
              credentials: 'include',
              body: JSON.stringify({
                  BreakStart: timeOnly,
                  Break: 1,
                  GeoTag: geoTag, // Save GeoTag for BreakStart
              }),
          });

          console.log(`${staff.Name} started break with GeoTag: ${geoTag}`);
      } else {
          setError('No clock-in record found for today. Please clock in before starting a break.');
          console.log('No clock-in record found for today.');
      }
  } catch (error) {
      console.error('Error handling break start/end:', error);
      setError('Failed to process break request. Please try again.');
  }

  setIsLoading(false);
  fetchStaff(); // Refresh staff data
};  // if (clock === true) {
  //   return <ClockInData />;
  // }

    if (lateArrival !== false) {
      return (
        <div className="fixed inset-0 sm:bg-gradient-to-br sm:from-blue-50 sm:via-indigo-50 sm:to-purple-50 sm:flex sm:items-center sm:justify-center sm:p-4 z-50 bg-white overflow-y-auto">
        <div className="bg-white sm:rounded-2xl sm:shadow-2xl w-full max-w-lg sm:border sm:border-gray-100 overflow-hidden min-h-screen sm:min-h-0 flex flex-col">
        {/* Header */}
        <div className="bg-gradient-to-r from-orange-500 to-red-500 px-6 py-6 sm:py-4 flex-shrink-0">
        <div className="flex items-center justify-center">
          <div className="bg-white/20 rounded-full p-3 mr-3">
          <ClockIcon className="h-6 w-6 text-white" />
          </div>
          <div>
          <h2 className="text-xl font-bold text-white">Late Arrival Notice</h2>
          <p className="text-orange-100 text-sm">Action Required</p>
          </div>
        </div>
        </div>
  
        {/* Content */}
        <div className="px-6 py-6 flex-1 flex flex-col justify-between">
        <div>
          <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 rounded-full mb-4">
          <span className="text-2xl">⚠️</span>
          </div>
          <p className="text-gray-700 text-base leading-relaxed">
          Hi <span className="font-semibold text-gray-900">{user.name}</span>, 
          you're clocking in later than your scheduled time. Please provide a brief explanation for your late arrival.
          </p>
          </div>
  
          <div className="space-y-4">
          <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
          Reason for Late Arrival <span className="text-red-500">*</span>
          </label>
          <textarea
          className="w-full p-4 border-2 border-gray-200 rounded-xl focus:border-orange-500 focus:ring-4 focus:ring-orange-100 transition-all duration-200 resize-none text-gray-700 placeholder-gray-400"
          rows="4"
          placeholder="e.g., Traffic delay, public transport issue, medical appointment..."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          maxLength={500}
          />
          <div className="flex justify-between items-center mt-2">
          <span className="text-xs text-gray-500">Be specific but concise</span>
          <span className="text-xs text-gray-400">{reason.length}/500</span>
          </div>
          </div>
          </div>
        </div>
  
        <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3 pt-6 mt-auto">
          <button
          onClick={() => {
          setLateArrival(false);
          setReason('');
          }}
          className="w-full sm:flex-1 px-4 py-3 border-2 border-gray-200 text-gray-700 font-medium rounded-xl hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-gray-100"
          >
          Cancel
          </button>
          <button
          onClick={handleLateArrivalSubmit}
          disabled={isLoading || !reason.trim()}
          className="w-full sm:flex-1 px-4 py-3 bg-gradient-to-r from-orange-500 to-red-500 text-white font-semibold rounded-xl hover:from-orange-600 hover:to-red-600 disabled:from-gray-300 disabled:to-gray-400 disabled:cursor-not-allowed transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-orange-200 shadow-lg"
          >
          {isLoading ? (
          <div className="flex items-center justify-center">
          <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Submitting...
          </div>
          ) : (
          'Submit Explanation'
          )}
          </button>
        </div>
        </div>
  
        {/* Footer */}
        <div className="bg-gray-50 px-6 py-3 border-t border-gray-100 flex-shrink-0">
        <p className="text-xs text-gray-500 text-center">
          This information will be recorded for attendance tracking purposes.
        </p>
        </div>
        </div>
        </div>
      );
    }

  return (
    <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-100 to-purple-100 p-4 sm:p-6 lg:p-8"
    >
        {/* Header with Break Time Display */}
        <motion.div 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="mb-6 sm:mb-8 lg:mb-12"
        >
            {/* Break Time Display - Top Section */}
            {breakData && breakData.length > 0 && (
                <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.4 }}
                    className="mb-6 bg-white/80 backdrop-blur-md rounded-2xl p-3 sm:p-4 border border-gray-200/50 shadow-lg max-w-sm"
                >
                    <h3 className="text-sm sm:text-base font-semibold text-gray-800 mb-2">Today's Break Times</h3>
                    <div className="space-y-1">
                        {breakData.map((breakItem, index) => (
                            <div key={index} className="text-xs sm:text-sm text-gray-600">
                                <div className="flex items-center space-x-2">
                                    <span className="text-yellow-500">☕</span>
                                    <span>
                                        {breakItem.BreakStart && breakItem.BreakEnd 
                                            ? `${breakItem.BreakStart} - ${breakItem.BreakEnd}`
                                            : breakItem.BreakStart 
                                            ? `${breakItem.BreakStart} - Active`
                                            : 'No break taken'
                                        }
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </motion.div>
            )}

            {/* Centered Title */}
            <div className="text-center">
                <h1 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent mb-2">
                    Attendance Portal
                </h1>
                <p className="text-gray-600 text-sm sm:text-base lg:text-lg">Manage your clock-in and break activities</p>
            </div>
        </motion.div>

        {/* Loading State */}
        {isLoading && !staffList?.length ? (
            <motion.div 
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                className="flex items-center justify-center min-h-[50vh] p-4 sm:p-8"
            >
                <div className="bg-white/80 backdrop-blur-md rounded-3xl p-8 sm:p-12 text-center border border-gray-200/50 shadow-xl">
                    <motion.div
                        animate={{ 
                            rotate: 360,
                            scale: [1, 1.1, 1]
                        }}
                        transition={{ 
                            rotate: { duration: 1, repeat: Infinity, ease: "linear" },
                            scale: { duration: 0.5, repeat: Infinity, repeatType: "reverse" }
                        }}
                        className="text-4xl sm:text-6xl mb-4"
                    >
                        ⚡
                    </motion.div>
                    <p className="text-gray-700 text-base sm:text-lg">Loading staff data...</p>
                </div>
            </motion.div>
        ) : !staffList || staffList.length === 0 ? (
            <motion.div 
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                className="flex items-center justify-center min-h-[50vh] p-4 sm:p-8"
            >
                <div className="bg-white/80 backdrop-blur-md rounded-3xl p-8 sm:p-12 text-center border border-gray-200/50 shadow-xl">
                    <div className="text-4xl sm:text-6xl mb-4">🔍</div>
                    <p className="text-gray-700 text-base sm:text-lg">No staff members found</p>
                </div>
            </motion.div>
        ) : (
            /* Staff Grid */
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-1 2xl:grid-cols-5 gap-4 sm:gap-6"
            >
                {staffList.map((staff, index) => (
                    <motion.div
                        key={staff.id || staff.Name}
                        initial={{ opacity: 0, y: 30, scale: 0.9 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        transition={{ 
                            delay: index * 0.1,
                            duration: 0.5,
                            type: "spring",
                            stiffness: 100
                        }}
                        whileHover={{ 
                            scale: 1.05,
                            transition: { duration: 0.2 }
                        }}
                        className="group relative"
                    >
                        {/* Glass Card */}
                        <div className="bg-white/70 backdrop-blur-lg rounded-3xl p-4 sm:p-6 border border-gray-200/30 shadow-xl hover:shadow-purple-500/20 transition-all duration-300 hover:border-purple-300/40 hover:bg-white/80">
                            {/* Status Indicator */}
                            <div className="absolute top-3 sm:top-4 right-3 sm:right-4">
                                <div className={`w-3 h-3 sm:w-4 sm:h-4 rounded-full ${
                                    staff.isClockedIn && !staff.isOnBreak
                                        ? 'bg-green-500 shadow-lg shadow-green-500/50' 
                                        : staff.isOnBreak
                                        ? 'bg-yellow-500 shadow-lg shadow-yellow-500/50'
                                        : 'bg-red-500 shadow-lg shadow-red-500/50'
                                } animate-pulse`}></div>
                            </div>

                            {/* Staff Avatar & Info */}
                            <div className="text-center mb-4 sm:mb-6">
                                <motion.div 
                                    whileHover={{ rotate: [0, -10, 10, -10, 0] }}
                                    transition={{ duration: 0.5 }}
                                    className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-3 sm:mb-4 bg-gradient-to-br from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center text-2xl sm:text-3xl shadow-xl"
                                >
                                    👤
                                </motion.div>
                                <h3 className="text-gray-800 font-semibold text-base sm:text-lg mb-1">{staff.Name}</h3>
                                <p className="text-gray-600 text-xs sm:text-sm">{staff.Position || 'Staff Member'}</p>
                                <div className={`inline-block px-2 sm:px-3 py-1 rounded-full text-xs font-medium mt-2 ${
                                    staff.isClockedIn && !staff.isOnBreak
                                        ? 'bg-green-100 text-green-700 border border-green-200' 
                                        : staff.isOnBreak
                                        ? 'bg-yellow-100 text-yellow-700 border border-yellow-200'
                                        : staff.clockedOut
                                        ? 'bg-blue-100 text-blue-700 border border-blue-200'
                                        : 'bg-red-100 text-red-700 border border-red-200'
                                }`}>
                                    {staff.isClockedIn && !staff.isOnBreak 
                                        ? 'Working' 
                                        : staff.isOnBreak 
                                        ? 'On Break'
                                        : staff.clockedOut
                                        ? 'Clocked Out'
                                        : 'Not Clocked In'
                                    }
                                </div>
                                {staff.clockInTime && (
                                    <p className="text-gray-500 text-xs mt-1">
                                        Clock In: {staff.clockInTime}
                                    </p>
                                )}
                                {staff.clockedOut && staff.clockOutTime && (
                                    <p className="text-gray-500 text-xs mt-1">
                                        Clock Out: {staff.clockOutTime}
                                    </p>
                                )}
                                {staff.breakStartTime && staff.breakEndTime && (
                                    <p className="text-gray-500 text-xs mt-1">
                                        Break: {staff.breakStartTime} - {staff.breakEndTime}
                                    </p>
                                )}

                            </div>

                            {/* Action Buttons */}
                            <div className="space-y-2 sm:space-y-3">
                                {/* Clock In/Out Button - Only show if not clocked out or if beforeClockin */}
                                {(!staff.clockedOut || staff.beforeClockin) && (
                                    <motion.button
                                        whileHover={{ scale: 1.02 }}
                                        whileTap={{ scale: 0.98 }}
                                        onClick={() => handleClockInOut(staff)}
                                        disabled={isLoading}
                                        className={`w-full p-3 sm:p-4 rounded-2xl font-semibold text-white shadow-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2 sm:space-x-3 text-sm sm:text-base ${
                                            !staff.isClockedIn
                                                ? 'bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 shadow-green-500/30'
                                                : 'bg-gradient-to-r from-red-500 to-rose-600 hover:from-red-600 hover:to-rose-700 shadow-red-500/30'
                                        } hover:shadow-xl`}
                                    >
                                        <motion.span 
                                            className="text-xl sm:text-2xl"
                                            animate={staff.isClockedIn ? { scale: [1, 1.2, 1] } : {}}
                                            transition={{ duration: 2, repeat: Infinity }}
                                        >
                                            {!staff.isClockedIn ? '🚀' : '🏠'}
                                        </motion.span>
                                        <span>
                                            {!staff.isClockedIn ? 'Clock In' : 'Clock Out'}
                                        </span>
                                    </motion.button>
                                )}

                                {/* Clocked Out Message - Show when clocked out */}
                                {staff.clockedOut && !staff.beforeClockin && (
                                    <motion.div
                                        initial={{ opacity: 0, scale: 0.9 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        className="w-full p-3 sm:p-4 rounded-2xl bg-gradient-to-r from-blue-500 to-indigo-600 text-white text-center shadow-lg"
                                    >
                                        <div className="flex items-center justify-center space-x-2 sm:space-x-3">
                                            <span className="text-xl sm:text-2xl">✅</span>
                                            <span className="font-semibold text-sm sm:text-base">Day Complete</span>
                                        </div>
                                        {staff.clockOutTime && (
                                            <p className="text-xs sm:text-sm text-blue-100 mt-1">
                                                Clocked out at {staff.clockOutTime}
                                            </p>
                                        )}
                                    </motion.div>
                                )}

                                {/* Break Button - Show when clocked in and not clocked out */}
                                {staff.isClockedIn && !staff.clockedOut && (
                                    <motion.button
                                        whileHover={{ scale: 1.02 }}
                                        whileTap={{ scale: 0.98 }}
                                        onClick={() => handleBreakStartEnd(staff)}
                                        disabled={isLoading}
                                        className={`w-full p-3 sm:p-4 rounded-2xl font-semibold text-white shadow-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center space-x-2 sm:space-x-3 text-sm sm:text-base ${
                                            staff.isOnBreak
                                                ? 'bg-gradient-to-r from-blue-500 to-cyan-600 hover:from-blue-600 hover:to-cyan-700 shadow-blue-500/30'
                                                : 'bg-gradient-to-r from-yellow-500 to-orange-600 hover:from-yellow-600 hover:to-orange-700 shadow-yellow-500/30'
                                        } hover:shadow-xl`}
                                    >
                                        <motion.span 
                                            className="text-xl sm:text-2xl"
                                            animate={staff.isOnBreak ? { rotate: [0, 10, -10, 0] } : {}}
                                            transition={{ duration: 1, repeat: Infinity }}
                                        >
                                            {staff.isOnBreak ? '⚡' : '☕'}
                                        </motion.span>
                                        <span>
                                            {staff.isOnBreak ? 'Back From Break' : 'Start Break'}
                                        </span>
                                    </motion.button>
                                )}
                            </div>
                        </div>

                        {/* Glow Effect */}
                        <div className="absolute inset-0 rounded-3xl bg-gradient-to-r from-purple-500/20 to-pink-500/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10 blur-xl"></div>
                    </motion.div>
                ))}
            </div>
        )}

        {/* Global Loading Overlay */}
        {isLoading && staffList?.length > 0 && (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="fixed inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center z-50"
            >
                <motion.div
                    animate={{ 
                        rotate: 360,
                        scale: [1, 1.1, 1]
                    }}
                    transition={{ 
                        rotate: { duration: 1, repeat: Infinity, ease: "linear" },
                        scale: { duration: 0.5, repeat: Infinity, repeatType: "reverse" }
                    }}
                    className="bg-white/90 backdrop-blur-md rounded-full p-6 sm:p-8 border border-gray-200/30 shadow-xl"
                >
                    <div className="text-3xl sm:text-4xl">⚡</div>
                </motion.div>
            </motion.div>
        )}

        {/* Error Display */}
        {error && (
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="fixed bottom-4 right-4 bg-red-100 backdrop-blur-md border border-red-300 text-red-700 px-4 sm:px-6 py-3 sm:py-4 rounded-2xl shadow-xl max-w-xs sm:max-w-sm"
            >
                <div className="flex items-center space-x-2">
                    <span className="text-lg sm:text-xl">⚠️</span>
                    <span className="text-sm sm:text-base">{error}</span>
                </div>
            </motion.div>
        )}
    </motion.div>
  );
}
